import React from "react";
import { FORM_ID } from "./config";

type tProps = {
  onSubmit: (...args: any) => any;
};
const TestPayoutRequest = (props: tProps) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        props.onSubmit({});
      }}
      id={FORM_ID}
    ></form>
  );
};

export default TestPayoutRequest;
